import { ComingSoonPage } from './ComingSoonPage';

export default function SocietyMap() {
  return (
    <ComingSoonPage
      title="Society Map"
      description="Explore residential societies, gated communities and developments across Ethiopia on an interactive map."
      canonical="https://ethiorealestates.com/society-map"
      tagline="Interactive map of residential societies and gated communities across Ethiopia — launching soon."
    />
  );
}
